import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    // assessment template json (the S3 file behind an assessment's url /
    // lookupNotes), keyed by that url
    templates: {},
}

const assessmentTemplatesSlice = createSlice({
    name: "assessmentTemplates",
    initialState,
    reducers: {
        setAssessmentTemplate: (state, action) => {
            const { url, json } = action.payload
            state.templates[url] = json
        },
    },
})

export const { setAssessmentTemplate } = assessmentTemplatesSlice.actions

export default assessmentTemplatesSlice.reducer
